export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    resumeEditorSetting: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {

  },
  mounted () {

  },
  methods: {
    async submit () {
      return true
    },
    async getForm () {
      if (this.show) {
        let form = this.$refs.form
        if (!form) {
          await this.$nextTick()
          form = this.$refs.form
        }
        return form
      }
      return null
    }
  }
}
